import { render, staticRenderFns } from "./ExtraContent.vue?vue&type=template&id=77f4c82f&"
import script from "./ExtraContent.vue?vue&type=script&lang=js&"
export * from "./ExtraContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports